import React, { FC, useState, useEffect } from 'react'
import { fanMe } from '../../store/actions/users'
import { User } from '../../models/user'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { RootState } from '../../store/reducers'
import avatar from '../../assets/images/avatar.png'
import { storage } from '../../firebase'

interface Props {
  user: User
  uid: string | null | undefined
}

const UserInfo: FC<Props> = ({ user, uid }) => {
  const [pimage, setPimage] = useState('')
  const {
    username,
    website,
    bio,
    location: { city, country },
    fans,
    id,
  } = user

  useEffect(() => {
    let mounted = true

    let t = document.querySelector('head')!
    let ttl = document.createElement('meta')
    let url = document.createElement('meta')
    ttl.setAttribute(`property`, 'og:title')
    ttl.setAttribute('content', `${username} - ${bio ? bio : 'A lodies user'}`)
    url.setAttribute(`property`, `og:url`)
    url.setAttribute(`content`, `https://lodies-app.web.app/usr/${username}`)
    t.appendChild(ttl)
    t?.appendChild(url)

    storage
      .ref(`profiles/${id}`)
      .getDownloadURL()
      .then((url) => {
        let img = document.createElement('meta')
        img.setAttribute(`property`, 'og:image')
        img.setAttribute('content', url)
        t.appendChild(img)
        if (mounted) setPimage(url)
      })

    return () => {
      mounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])
  if (!user) return <Redirect to={'/feed'} />

  console.log(document.querySelector(`head`))

  const isFan = uid ? fans.includes(uid) : false

  return (
    <div className="profile-head">
      <div className="left">
        {/* {pimage ? (
          <img src={pimage} alt="" className="profile-img" />
        ) : ( */}
        <div
          className="profile-img"
          style={{
            backgroundSize: 'contain',
            background: pimage ? `url(${pimage})` : `url(${avatar})`,

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* <img src={avatar} alt="" className="profile-img" /> */}
        </div>
        {/* )} */}
      </div>
      <div className="right">
        <div className="pinfo">
          <h3 className="app-text">{username}</h3>
          <div>
            <span style={{ textTransform: 'capitalize' }}>{city}</span>
            {city || country ? ', ' : ' '}
            <span style={{ textTransform: 'capitalize' }}>{country}</span>
          </div>
          <div>
            {/*eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a
              href={`https://${website}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {website}
            </a>
          </div>
          <p>
            {fans.length} {fans.length === 1 ? 'fan' : 'fans'}
          </p>
        </div>
        <div>
          <button
            className="fan-me"
            onClick={() => {
              fanMe(username)
            }}
          >
            {isFan ? (
              <span style={{ color: '#27a973' }}>
                <i className="material-icons-outlined">how_to_reg</i>
              </span>
            ) : (
              <span>
                <i className="material-icons-outlined">person_add</i>
                Fan me
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

const mapState = (state: RootState) => ({
  uid: state.auth.user.id,
})

export default connect(mapState)(UserInfo)
